/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotomake3Inputs */

const en_aiflowphotomake3 = /** @type {(inputs: Aiflowphotomake3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create pictures`)
};

const de_aiflowphotomake3 = /** @type {(inputs: Aiflowphotomake3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder erstellen`)
};

/**
* | output |
* | --- |
* | "Create pictures" |
*
* @param {Aiflowphotomake3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotomake3 = /** @type {((inputs?: Aiflowphotomake3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotomake3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotomake3(inputs)
	return de_aiflowphotomake3(inputs)
});
export { aiflowphotomake3 as "aiFlowPhotoMake" }